/**
 * Shared validation utilities for phone and email fields
 */

// Regex patterns
export const phoneRegex = /^\d{10}$/
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/**
 * Validate phone number (exactly 10 digits)
 * @param {string} phone - Phone number to validate
 * @returns {boolean} True if valid
 */
export function validatePhone(phone) {
  if (!phone) return false
  return phoneRegex.test(phone)
}

/**
 * Validate email format
 * @param {string} email - Email to validate
 * @returns {boolean} True if valid or empty (optional field)
 */
export function validateEmail(email) {
  if (!email) return true // Optional field
  return emailRegex.test(email)
}

/**
 * For Naive UI n-input :allow-input prop - only allows digits
 * @param {string} value - Input value
 * @returns {boolean} True if value contains only digits
 */
export function allowOnlyDigits(value) {
  return /^\d*$/.test(value)
}

/**
 * Naive UI form validation rules for phone
 */
export const phoneRules = [
  { required: true, message: 'Phone number is required', trigger: 'blur' },
  { pattern: phoneRegex, message: 'Enter 10 digit phone number', trigger: 'blur' }
]

/**
 * Naive UI form validation rules for email (optional)
 */
export const emailRules = [
  {
    validator: (rule, value) => {
      if (!value) return Promise.resolve()
      if (emailRegex.test(value)) return Promise.resolve()
      return Promise.reject(new Error('Enter a valid email address'))
    },
    trigger: 'blur'
  }
]

/**
 * Naive UI form validation rules for email (required)
 */
export const emailRequiredRules = [
  { required: true, message: 'Email is required', trigger: 'blur' },
  { pattern: emailRegex, message: 'Enter a valid email address', trigger: 'blur' }
]
